module.exports = __webpack_public_path__ + "img/early_03.ef9908c7.png";